"use strict";
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spread = (this && this.__spread) || function () {
    for (var ar = [], i = 0; i < arguments.length; i++) ar = ar.concat(__read(arguments[i]));
    return ar;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.responsiveStylesFn = void 0;
var sizes = ['small', 'medium', 'large', 'xlarge'];
/**
 * Combine appropriate "per breakpoint" styles, cascading responsively upwards.
 */
function responsiveStyles(size, styles) {
    var relevantStyles = sizes
        .filter(function (currentSize) {
        return styles.hasOwnProperty(currentSize) &&
            // Only include styles for equal or greater than breakpoints
            sizes.indexOf(size) >= sizes.indexOf(currentSize);
    })
        .map(function (currentSize) { return styles[currentSize]; });
    return relevantStyles.length > 0 ? __spread(relevantStyles, [{ label: size }]) : [];
}
exports.default = responsiveStyles;
function responsiveStylesFn(styles) {
    return function (size) { return responsiveStyles(size, styles); };
}
exports.responsiveStylesFn = responsiveStylesFn;
